import React from "react";

import { Stack } from "@mui/material";

import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";

const TransitionProgressIndicatorSkeleton: React.FC = () => {
  return (
    <Stack
      direction="row"
      spacing={0.25}
      sx={{
        width: "100%",
      }}
    >
      {/* Simulate 3-4 progress segments */}
      <Skeleton
        variant="rounded"
        height={48}
        sx={{
          flex: 1,
          borderRadius: "100px 0 0 100px",
        }}
      />
      <Skeleton variant="rounded" height={48} sx={{ flex: 1 }} />
      <Skeleton variant="rounded" height={48} sx={{ flex: 1 }} />
      <Skeleton
        variant="rounded"
        height={48}
        sx={{
          flex: 1,
          borderRadius: "0 100px 100px 0",
        }}
      />
    </Stack>
  );
};

export default TransitionProgressIndicatorSkeleton;
